/// AI-recommendation lifecycle. Mirrors the server's `AdoptionStatus` enum.
export type AdoptionStatus = 'pending' | 'accepted' | 'rejected' | 'superseded';

export const ADOPTION_STATUS_LABELS: Record<AdoptionStatus, string> = {
  pending: '採否未定',
  accepted: '採用',
  rejected: '却下',
  superseded: '失効 (新しい実行に置き換わり)',
};

export interface AiRecommendationItem {
  id: string;
  recommendation_id: string;
  product_id: string;
  rank: number | null;
  score: number;
  score_breakdown: unknown;
  reason: string | null;
  exclusion_reason: string | null;
  is_excluded: boolean;
  created_at: string;
  updated_at: string;
}

export type RecommendationTargetKind = 'firm' | 'lawyer';

export interface AiRecommendation {
  id: string;
  target_kind: RecommendationTargetKind;
  firm_id: string | null;
  lawyer_id: string | null;
  recommendation_type: string;
  adoption_status: AdoptionStatus;
  generated_at: string;
  title: string | null;
  body: string | null;
  feature_evidence: unknown;
  confidence_score: number | null;
  model_name: string | null;
  accepted_or_rejected_reason: string | null;
  outcome_feedback: unknown;
  history: unknown;
  source: string;
  /// 担当者 (app_accounts.id, ACC-5)。 未割当は null。
  assignee_account_id: string | null;
  created_at: string;
  updated_at: string;
  items: AiRecommendationItem[];
}

export interface PagedRecommendations {
  items: AiRecommendation[];
  total: number;
  page: number;
  page_size: number;
}

export interface RecommendationListQuery {
  target_kind?: RecommendationTargetKind;
  firm_id?: string;
  lawyer_id?: string;
  adoption_status?: AdoptionStatus;
  sort_by?: 'generated_at' | 'created_at' | 'updated_at';
  sort_dir?: 'asc' | 'desc';
  page?: number;
  page_size?: number;
}

export interface RecommendationPatchRequest {
  title?: string | null;
  body?: string | null;
  feature_evidence?: unknown;
  model_name?: string | null;
  outcome_feedback?: unknown;
  recommendation_type?: string;
  /// 担当者の付替 (ACC-5)。 空文字/null=未割当、 id=割当。
  assignee_account_id?: string | null;
}

export interface RecommendationTransitionRequest {
  next: AdoptionStatus;
  reason?: string;
  comment?: string;
}
